import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import Plural from 'components/utils/Formatters/Plural'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import LineTaxiIcon from 'components/Luxkit/Icons/line/LineTaxiIcon'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  numberOfBenefitRemaining: number
}

function LandingPageLoyaltyAirportTransferBenefitsModal(props: Props) {
  const { image, tier, numberOfBenefitRemaining } = props
  return (
    <ModalBase size="L">
      <ModalHeader title="Free airport chauffeur service" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            {!!numberOfBenefitRemaining && <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={`${getLoyaltyTierDisplayName(tier)} Member Benefit`}
              icon={<LineTaxiIcon />}
            >
              <BodyText variant="medium">
                You have {numberOfBenefitRemaining > 1 ? `${numberOfBenefitRemaining}x` : 'a'} airport chauffeur{' '}
                <Plural count={numberOfBenefitRemaining} singular="service" plural="services" /> per booking, unlimited throughout the year.
              </BodyText>
            </LoyaltyTierCallOutBanner>}
            <BodyText variant="large">
              Start your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                When booking an overseas hotel, you will get the option to add the home-to-airport transfer during{' '}
                the checkout process before you book. The transfer is complimentary within 30km of the airport,{' '}
                with a small fee for longer distances.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyAirportTransferBenefitsModal
